import type { NodeTypes } from '@xyflow/react';
import { OrgRootNode } from './OrgRootNode';
import { OrgAreaNode } from './OrgAreaNode';
import { OrgMemberNode } from './OrgMemberNode';
import { OrgProjectNode } from './OrgProjectNode';

export const orgChartNodeTypes: NodeTypes = {
  'org-root': OrgRootNode,
  'org-area': OrgAreaNode,
  'org-member': OrgMemberNode,
  'org-project': OrgProjectNode,
};
